export default {
    install(Vue)  {
        Vue.prototype.$jump = function(href, type) {
            let _this = this;
            if(type==="router"){
                _this.$router.push(href);
                document.documentElement.scrollTop = 0;
            }else{
                window.open(href);
            }
        };
    }
}
